export const removeStylingLinksFromDifferentPilets = (piletName: string) => {
  if (piletName) {
    document.querySelectorAll(`link:not([data-origin='${piletName}'])`).forEach((node) => {
      if ((node.getAttribute("data-origin") ?? "").indexOf("opencak") >= 0) {
        node.remove();
      }
    });
  }
};
